module.exports = __webpack_public_path__ + "static/media/students-collaborating.24dca9e5.jpg";